import { stringify } from 'query-string';
import util from '../libs/utils/util';
import { GOLD_PRICE, ORDER_ICON_THEME } from '@/libs/utils/consts'
import cookie from '@/libs/utils/cookie';

export default {
  SAVE_EXPERIMENT_CONFIG(state, payload) {
    state.experiment = payload
  },
  // 保存openid
  SAVE_OPENID(state, openid) {
    state.openid = openid;
  },
  // 保存unionid
  SAVE_UNIONID(state, unionid) {
    state.unionid = unionid;
  },
  SAVE_HOME_USER_INFO(state, payload) {
    // state.user_img = payload.user.headimgurl;
    // state.user_name = payload.user.nickname || '尊敬的用户';
    state.sex = payload.user.sex;
    state.is_plusvip = payload.user.is_plusvip; // 是否开通plus会员
    state.is_old_user = payload.user.is_old_user;
    state.isGrayscale = !!payload.user.is_craber;
    state.is_72hour = !!payload.user.is_72hour;
    state.is_low_price = !!payload.user.is_low_price;
    state.balance = payload.charge.balance;
    state.is_vip = !!payload.vip;
    state.goldPrice = payload.vip ? GOLD_PRICE.vip : GOLD_PRICE.notVip
    state.vip_end_time = payload.vip.split(' ')[0];
    state.barchat_send_times = payload.user.barchat_send_times;
    state.vip_endtime = payload.vip_endtime;
    state.is_expired_vip = Date.now() > new Date(payload.vip_endtime.replace(/-/g, '/')).getTime();
    state.showOpenToast = payload.showOpenToast
    state.showSongToast = payload.showSongToast
    state.isVipSongWhite = payload.isVipSongWhite || payload.stb.no_any_recreation
    state.isVipFirstToast = payload.isVipFirstToast
    state.vip_type_230906 = payload.user.vip_type_230906
    state.role = payload.role
    state.is90ExpireDevice = payload.expired90s
    state.is_refund_black = payload.user.is_refund_black || 0 // 是否在退款黑名单中
    state.showInvoiceEntry = payload.showInvoiceEntry || false // 是否显示发票入口
  },
  SAVE_VIP_TYPE_230906(state, data) {
    state.vip_type_230906 = data
  },
  // 用户信息/判断是否是vip
  SAVE_USER_INFO(state, payload) {
    state.user_img = payload.headimgurl;
    state.user_name = payload.nickname || '尊敬的用户';
    state.balance = payload.balance;
    // state.is_vip = !!payload.vip_time
    // state.vip_end_time = payload.vip_time.split(' ')[0]
    state.song_like_count = payload.song_like_count;
    state.appmusic_count = payload.appmusic_count;
    state.my_uploadsong = payload.my_uploadsong;
    state.my_contest = payload.my_contest;
    state.on_last_month_isvip = payload.on_last_month_isvip;
  },
  BLESS_PATH(state, data) {
    if (data === 1) {
      state.bless_path = '/thunder/blessv1';
    } else if (state.ktvid > 0) {
      state.bless_path = '/thunder/interact';
    } else {
      state.bless_path = '/thunder/bar';
    }
  },
  PHOTO_PATH(state, data) {
    if (data === 1 || data === 2) {
      state.photo_path = '/thunder/photo';
    } else {
      if (state.photoPag) {
        state.photo_path = '/thunder/photo_pag1';
      } else {
        state.photo_path = '/thunder/photov2';
      }
    }
    const pathMap = {
      '/thunder/photo': {
        label: '单张',
        class: 'single-photo',
        id: 1,
        entrance: 'photo'
      },
      '/thunder/photov2': {
        label: '多张',
        class: 'photo-v2',
        id: 2,
        entrance: 'photoV2'
      },
      '/thunder/photo_pag1': {
        label: 'pag版',
        class: 'pag-photo',
        id: 3,
        entrance: 'photoPag'
      },
    };
    state.photoPath = pathMap[state.photo_path] || { label: '未知', class: 'unknown' };
  },
  PHOTO_PATH_NEW(state, data) {
    const paths = {
      1: '/thunder/photo',
      2: '/thunder/photo',
      default: state.photoPag ? '/thunder/pag/photo' : '/thunder/photov2'
    };
    state.photo_path_new = paths[data] || paths.default;
  },
  PHOTO_INTERACT_PATH_NEW(state, data) {
    const paths = {
      1: '/thunder/png/photo',
      2: '/thunder/png/photo',
      default: state.photoPag ? '/thunder/pag/photo' : '/thunder/png/photov2'
    };
    state.photo_interact_path_new = paths[data] || paths.default;
  },
  SHOW_BARRAGE(state, data) {
    state.show_barrage = data;
  },
  // 获取页面来源
  SET_FROM_TYPE(state, path) {
    state.from_type = util.getUrlPrem('fromType', path) || util.getUrlPrem('FromType', path) || 'default';
  },
  PAGE_STATISTICS(state, opts) {
    if (!opts) return;
    let page = opts.url;
    const endTime = Math.ceil(new Date().getTime());
    const startTime = localStorage.getItem('startTime');
    // 单人包场统计 start
    const soloScene = ['photo_pag1', 'photov2', 'photo', 'photo_doutu', 'photov2_doutu', 'bless_pag1', 'bless_sort']
    const pagScene = ['opening_effect', 'opening_pag_effect', 'home', 'customer']
    let isSoloScene = false
    let isPagScene = false
    soloScene.forEach((item) => {
      if (page.includes(item)) {
        isSoloScene = true
      }
    })
    if (isSoloScene) {
      if (page.includes('?')) {
        page += `&issolo=${state.isSingleRights ? 1 : 0}`
      } else {
        page += `?issolo=${state.isSingleRights ? 1 : 0}`
      }
    }
    pagScene.forEach((item) => {
      if (page.includes(item)) {
        isPagScene = true
      }
    })
    // 单人包场统计 end
    // PAG相关场景统计 start
    if (isPagScene) {
      if (page.includes('?')) {
        page += `&is_pag=${state.supportPAG ? 1 : 0}`
      } else {
        page += `?is_pag=${state.supportPAG ? 1 : 0}`
      }
    }
    // PAG相关场景统计 end
    const params = {
      openid: state.openid,
      unionid: state.unionid,
      page,
      fr: state.from_type,
      ktv_id: state.ktvid,
      time: endTime - startTime,
      is_vip: state.is_vip ? 1 : 0,
      is_cc: state.ccTotal,
      str10: state.role,
      ...opts,
    };
    const src = `https://log6.ktvsky.com/wx/song/report?${stringify(params)}${state.room_stat}`;
    let img = new Image(1, 1);
    img.src = src;
    img.onload = () => {
      img = null;
    };
  },
  SAVE_ROOM_INTERACTION(state, data) {
    state.have_mv = data.mv;
    state.have_bullet = data.bullet;
    state.have_like = data.like;
    state.have_emoji = data.emoji;
    state.have_gift = data.gift && state.isSupportInteract || 0;
    state.have_photo = data.photo;
    state.istopVip = data.vip;
    state.songDel = data.songDel;
    state.have_score = data.score;
    state.have_mic = data.mic;
    state.have_video = data.video;
    state.ksong = data.ksong;
    state.have_jinhai = data.jinhai;
    state.have_xiaoai = data.ba === 4 ? 1 : 0; // 是否支持小爱语音播报
    state.Mac = data.mac // 保存房台信息，用于点餐接口
    state.photoPag = data.photoPag // 是否支持pag版发照片
    state.giftPag = data.giftPag // 是否支持pag版发礼物
    state.blessPag = data.blessPag // 是否支持pag版发祝福
    state.supportPAG = data.blessPag || data.photoPag || data.giftPag
    state.hideOrderedDelete = data.del_song !== 1 // 是否隐藏已点删除按钮
  },
  CHANGE_ORDER_NUM(state, data) { // 改变点歌次数
    state.order_num = data;
  },
  CHANGE_ORDEREDSONG_NUM(state, data) { // 改变已点歌次数
    state.orderedSongNum = data;
    cookie.setCookie(data, 3 / 24, 'orderSongnum')
  },
  CHANGE_MYORDEREDSONG_NUM(state, data) { // 改变我的已点歌次数
    state.myOrderedSongNum = data;
    cookie.setCookie(data, 3 / 24, 'myOrderedSongNum')
  },
  SAVE_PACKAGE_DISCOUNT_RIGHTS(state, data) {
    state.zf_num = data.zf_num || 0;
    state.gm_num = data.gm_num || 0;
    state.lw_num = data.lw_num || 0;
    state.zp_num = data.zp_num || 0;
  },
  SAVE_ZF_NUM(state, type) {
    state.zf_num = type;
  },
  SAVE_GM_NUM(state, type) {
    state.gm_num = type;
  },
  SAVE_LW_NUM(state, type) {
    state.lw_num = type;
  },
  SAVE_ZP_NUM(state, type) {
    state.zp_num = type;
  },
  SHOW_PLAY_CONTROL(state, data) {
    state.showPlaycontrol = data;
  },
  SAVE_KTV_INFO(state, ktvInfo) {
    state.ktvid = ktvInfo.ktvid;
    state.ktv_name = ktvInfo.ktv_name;
    state.roomid = ktvInfo.room_id;
    state.room_ip = ktvInfo.room_ip;
    state.bind_status = !!ktvInfo.ktvid;
    state.ktv_level = ktvInfo.ktv_level;
    state.room_stat = ktvInfo.stat;
    state.is_leishi_device = ktvInfo.stat.includes('ktype=ls'); // 雷石
    state.is_leike_device = ktvInfo.stat.includes('ktype=lk'); // 雷客
    state.is_leike_device_new = ktvInfo.stat.includes('ktp=lk'); // 雷客我的页
    state.is_bar_device = ktvInfo.stat.includes('ktype=bar'); // 酒吧
    state.is_huisuo_device = ktvInfo.stat.includes('ktype=club'); // 会所
    state.stb_tp = ktvInfo.tp != null ? String(ktvInfo.tp) : '';
    state.is_huisuo_disco = ktvInfo.stat.includes('ktp=club'); // 支持蹦迪会所
    state.user_scan_fr = ktvInfo.user_scan_fr;
    state.isSupportInteract = !ktvInfo.no_any_recreation // 是否支持互动
    state.isBlockInteractText = !!ktvInfo.forbidRecreation // 是否禁止文字上屏
    state.isLeikeLinux = (ktvInfo.ktvid == -9)
  },
  SHOW_NOTVIP(state, data) {
    state.showNotVip = data;
  },
  SHOW_NOTVIP_TITLE(state, data) {
    state.showNotVipTitle = data;
  },
  SHOW_NOTVIP_TIMER(state, data) {
    if (!data) {
      clearTimeout(state.notVipTimer);
      state.notVipTimer = null;
    } else {
      state.notVipTimer = data;
    }
  },
  SAVE_HOME_TOAST(state, data) {
    state.showHomeToast = data;
  },
  SET_INVOICE_ENTRY(state, data) {
    state.showInvoiceEntry = data;
  },
  SET_CONTROL_PAD(state, show) {
    state.showPad = show;
  },
  INIT_ENTER_PAGE(state, data) {
    state.init_enter = data;
  },
  SET_RANK_INFO(state, data) {
    state.rank_info = data;
  },
  CHANGE_HOME_BOTTOM_AD(state, data) {
    state.homeBttomAdShow = data;
  },
  SHOW_HOME_BOTTOM_AD(state, data) {
    state.homeBottomAdShow = data;
  },
  SET_ACTIVITY_OVER(state, data) {
    state.isActivityOver = data;
  },
  INIT_WX_CONFIG(state) {
    state.wxconfig = true;
  },
  IS_MIN_PROGRAM(state, flag) {
    state.isMinProgram = flag;
  },
  SET_FANS_MODAL_VIP(state, data) {
    state.fansModalVipShow = data;
  },
  SET_RECOMMEND_PHOTO(state, data) {
    state.recommendPhotoShow = data;
  },
  SET_LIKE_SONG(state, data) {
    state.likeSongs = data;
  },
  SET_IS_GOLD(state, data) {
    state.isGold = data;
  },
  SET_GOLD_MASTER(state, data) {
    state.isGoldMaster = data;
  },
  SET_GOLD_MESSAGE(state, data) {
    state.goldMessage = data;
  },
  SET_IS_SINGLE_RIGHTS(state, data) {
    state.isSingleRights = !!data.isSolobc
    state.SREndTime = data.endTime
  },
  SET_SONG_ADDED_TOAST(state, data) {
    state.is_song_added_toast = data;
  },
  SAVE_TOGGLE_SKELETON(state, data) {
    state.skeletonName = data;
  },
  SET_IS_VIP(state, data) {
    state.vip_end_time = data.end_time.split(' ')[0];
    state.vip_endtime = data.end_time
    state.is_vip = !!data.vip;
    state.goldPrice = data.vip ? GOLD_PRICE.vip : GOLD_PRICE.notVip
  },
  SAVE_IS_RAISE(state, data) {
    state.isRaisePrice = data.isExpire || data.isRich // 是否显示提价套餐
    state.isPayedRaisePrice = data.isRich // 是否支付过提价的套餐
  },
  SET_GOLD_MODAL(state, data) {
    state.openGold = data;
  },
  SET_GM_SWITCH(state, data) {
    state.gmSwitch = Number(data);
  },
  SET_WEIXIN_APPID(state, data) {
    if (state.appId) return
    state.appId = data;
  },
  SAVE_IS_PLUS_VIP(state, data) {
    state.is_plusvip = data; // 是否开通plus会员
  },
  SET_DRAG_DISABLE_AREA(state, data) {
    state.dragDisableArea = data;
  },
  SET_VIP_ENDTIME(state, data) {
    state.vip_endtime = data;
  },
  SAVE_IS_VIP(state) {
    state.is_vip = true;
    state.goldPrice = GOLD_PRICE.vip
    state.is_expired_vip = false;
  },
  SET_LIKE_SONG_NEW(state, data) {
    state.is_song_like_new = data;
  },
  // 常唱新规则：https://m2miovoqda.feishu.cn/docx/YuSod93xnocQ2ZxPcpCcdth9nOg
  SET_CCTOTAL(state, data) {
    state.ccTotal = data;
  },
  SET_CCTOTAL_SHOW(state, data) {
    state.ccTotalShow = data;
  },
  SET_SPECIAL_CONTROL(state, data) {
    state.special_control = data;
  },
  SAVE_LITONG_INFO(state, data) {
    state.litongInfo = data
  },
  SAVE_SEARCH_DEFAULT_TEXT(state, data) {
    state.searchDefaultText = data;
  },
  SET_ORDER_LIST(state, data) {
    state.isShowOrderList = data
  },
  SET_INTERVAL_ORDERLIST(state, data) {
    state.intervalShowOrderList = data
  },
  SET_CURRENT_ORDERINDEX(state, data) {
    state.currentOrderIndex = data
  },
  SET_CURRENT_TAB(state, data) {
    state.activeTab = data
  },
  SET_ORDERSUCCESS_TOAST(state, data) {
    if (data) {
      state.orderSuccessConfig = data
    }
    state.orderSuccessVisible = !!data
  },
  SAVE_MINIPAY_CALLBACK(state, payload) {
    state.miniPayCallback = payload
  },
  SET_DISCO_START(state, data) {
    state.isDiscoStart = data
  },
  SAVE_VIP_EXPERIENCE(state, data) {
    state.hasFreeVipM = !!data.hasFreeVipM // 是否有资格领取体验VIP
    state.isFreeVipM = !!data.isFreeVipM // 是否领取过体验VIP
  },
  SET_CUSTOMER_COUNTDOWN(state, data) {
    state.customerCountProcess = data
  },
  SET_APP_HISTORY(state, data) {
    state.appHistory = data
  },
  SAVE_AGREE_SHOW(state, data) {
    state.isAgreeShow = data
  },
  SAVE_INDEX_NAV_DATA(state, data) {
    state.indexNavData = data
  },
  SAVE_LEIKE_LINUX_IFNO(state, data) {
    state.isLeikeExpire = data.isLeikeExpire
    state.leikeJumpUrl = data.leikeJumpUrl
  },
  SAVE_SETTOP_DATE(state, data) {
    state.SetTopDate = data
  },
  SAVE_SHOW_SCODE_BOX(state, data) {
    state.isShowScode = data
  },
  SAVE_USER_ROLE(state, data) {
    state.role = data
  },
  SET_THEME(state, theme) {
    state.$theme = theme;
    state.themeOrderIcon = ORDER_ICON_THEME[theme]
    document.documentElement.setAttribute('data-theme', theme);
  },
  SAVE_SHOW_GIFT_BOX(state, data) {
    state.isShowGiftBox = data
  },
  SET_SHOW_PHOTO_TOAST(state, data) {
    if (typeof data === 'object') {
      state.showPhotoToast = data.show
      state.photoToastEntrance = data.entrance
    } else {
      state.showPhotoToast = data
    }
  },
  SET_SHOW_PAY_TOAST(state, data) {
    state.isShowPayToast = data
  },
  SET_SHOW_VOICE_SEARCH(state, data) {
    state.isShowVoiceSearch = data
  },
  SET_PENDING_PAYMENT(state, data) {
    state.pendingPayment = data
  },
  SET_CONTROL_BOTTOM(state, value) {
    state.isControlBottom = value;
  },
  SET_WALLPAPER_DATA(state, value) {
    state.wallpaperData = value;
  },
  SAVE_DEVICE_INFO(state, value) {
    state.is_lk_linux_vipsong = ['SKYROCKER_JYPLUS', 'SR3719c_JYVS'].includes(value);
  },
  SAVE_HAS_PHOTO_PRIVILEGE(state, value) {
    state.hasPhotoPrivilege = value;
  },
};
